import React from "react";

interface AuthErrorPageProps {
  title: string;
  detail: string;
  onRetry?: () => void;
}

/** Shown instead of a blank app when sign-in cannot start or fails. */
export function AuthErrorPage({ title, detail, onRetry }: AuthErrorPageProps) {
  return (
    <main style={{ maxWidth: 640, margin: "64px auto", padding: "0 16px", fontFamily: "sans-serif" }}>
      <div role="alert">
        <h1 style={{ fontSize: 22 }}>{title}</h1>
        <p>{detail}</p>
      </div>
      {onRetry ? (
        <button type="button" onClick={onRetry}>
          Sign in again
        </button>
      ) : null}
    </main>
  );
}
